// todo MATAN: who use this file? need to move to correct place

const styleTalentDetails = {
  cardContent: {
    form: {
      width: '100%',
      boxLabel: {
        xs: 3,
      },
      boxInput: {
        xs: 8,
      },
      boxIcon: {
        xs: 1,
        textAlign: 'end',
        box: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-evenly',
          height: '31px',
        },
        boxAddnew: {
          textAlign: 'end',
          mr: 2,
        },
        checkCircle: {
          color: '#EC0982',
        },
      },
      box: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        padding: '15px',
        '&:hover': {
          backgroundColor: 'rgba(80, 72, 229, 0.08);',
        },
      },
      error: {
        color: 'error.main',
        variant: 'caption',
        backgroundColor: 'rgba(209, 67, 67, 0.12)',
        sx: {
          ml: 2,
        },
        dividerError: {
          border: '1px solid #D14343',
        },
      },
      InputLabel: {
        width: '220px',
        paddingLeft: '15px',
        fontWeight: '600',
        color: '#130F35',
      },
      TextField: {
        backgroundColor: 'none',
        display: 'flex',
        alignItems: 'center',
        color: '#6B7280',
      },
      CardContent: {
        removePB: {
          paddingBottom: '0px',
        },
        sx: {
          p: 0,
          mx: 0,
        },
      },
    },
  },
} as const;
  
export {
  styleTalentDetails,
};
